<div class="[ cluster cluster-space-2xs ]">
  <button
    type="button"
    class="[ action flex-nowrap items-center ] [ cursor-pointer ]"
    [attr.aria-label]="ariaLabel"
    [attr.aria-selected]="selected || undefined"
    [disabled]="disabled || undefined"
    role="option"
    tabindex="-1"
    >
    @if (selected) {
      <dcr-icon icon="actions:done" class="campus-icon [ icon-size-s ]" aria-hidden="true"></dcr-icon>
    }
    @if (!selected && leadingIcon) {
      <dcr-icon
        [attr.icon]="leadingIcon"
        class="campus-icon [ icon-size-s ]"
        aria-hidden="true"
      ></dcr-icon>
    }

    <span class="[ label-large truncate ]">{{ label }}</span>

    @if (removable) {
      <button
        class="[ action ] [ icon-size-s ] [ on-surface-variant hover:on-surface ] [ cursor-pointer ] [ transition-colors ]"
        [attr.aria-label]="ariaLabelRemove"
        [disabled]="disabled"
        tabindex="-1"
        (click)="handleRemoveClick()"
        data-cy="btn-chip-remove"
        >
        <dcr-icon icon="navigation:close" class="campus-icon [ icon-size-s ]" aria-hidden="true"></dcr-icon>
      </button>
    }
  </button>
</div>

<ng-template #content> </ng-template>

<campus-state-layer
  [for]="element"
  [ngClass]="selected ? 'bg-on-secondary-container' : 'bg-on-surface-variant'"
></campus-state-layer>

<campus-focus-ring [for]="element"></campus-focus-ring>
